export enum CartOrderMode {
  ADDED = "ADDED",
  COURSE = "COURSE",
}
